import {
  HIDE_BLOCKING_OVERLAY,
  HIDE_LOADER,
  SHOW_BLOCKING_OVERLAY,
  SHOW_LOADER,
} from "./loaderActions";

interface LoaderState {
  isLoading: boolean;
  isBlocking: boolean;
}

const initialState: LoaderState = {
  isLoading: false,
  isBlocking: false,
};

const loaderReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SHOW_LOADER:
      return { ...state, isLoading: true, isBlocking: false };
    case HIDE_LOADER:
      return { ...state, isLoading: false };
    case SHOW_BLOCKING_OVERLAY:
      return { ...state, isBlocking: true };
    case HIDE_BLOCKING_OVERLAY:
      return { ...state, isBlocking: false };
    default:
      return state;
  }
};

export default loaderReducer;